import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { HugeiconsIconComponent, type IconSvgObject } from '@hugeicons/angular';
import {
  Alert02Icon,
  CheckmarkCircle02Icon,
  Cancel01Icon,
  InformationCircleIcon,
  MultiplicationSignIcon,
} from '@hugeicons/core-free-icons';
import { ToastService } from './toast.service';
import type { Toast, ToastVariant } from './toast.types';

const TOAST_ICON: Record<ToastVariant, IconSvgObject> = {
  success: CheckmarkCircle02Icon,
  error: Cancel01Icon,
  warning: Alert02Icon,
  info: InformationCircleIcon,
};

/** Mount once in the app shell; features raise toasts through {@link ToastService}. */
@Component({
  selector: 'ui-toast-container',
  standalone: true,
  imports: [HugeiconsIconComponent],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  private readonly toastService = inject(ToastService);

  protected readonly toasts = this.toastService.toasts;
  protected readonly CloseIcon = MultiplicationSignIcon;

  protected icon(variant: ToastVariant): IconSvgObject {
    return TOAST_ICON[variant];
  }

  /** Errors and warnings interrupt the screen reader; the rest wait their turn. */
  protected liveRole(variant: ToastVariant): 'alert' | 'status' {
    return variant === 'error' || variant === 'warning' ? 'alert' : 'status';
  }

  protected dismiss(toast: Toast): void {
    this.toastService.dismiss(toast.id);
  }
}
